import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: number;
  username: string;
  email?: string;
  name?: string;
  role: string;
  department?: string;
}

interface UserState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  login: (token: string, user: User) => void;
  logout: () => void;
}

const clearSessionViews = () => {
  try {
    sessionStorage.clear();
  } catch (error) {
    console.warn('清除会话视图失败:', error);
  }
};

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      setToken: (token) => set({ token, isAuthenticated: !!token }),
      setUser: (user) => set({ user }),
      login: (token, user) => {
        if (get().user?.id !== user.id) clearSessionViews();
        set({ token, user, isAuthenticated: true });
      },
      logout: () => {
        clearSessionViews();
        set({ token: null, user: null, isAuthenticated: false });
      },
    }),
    {
      name: 'user-storage',
    }
  )
);
